import classNames from 'classnames';

import CleanButton from '../../../CleanButton/CleanButton';
import SVG from '../../../SVG/SVG';

import closeIcon from './graphics/close.svg?raw';

import styles from './DialogCloseButton.module.css';

type DialogCloseButtonProps = {
    onClick?: () => void;
    position?: 'topRight' | 'bottomCenter';
};

const DialogCloseButton = ({ position, onClick }: DialogCloseButtonProps) => {
    return (
        <CleanButton
            onClick={onClick}
            className={classNames(styles.Root, {
                [styles.Root_topRight]: position === 'topRight',
                [styles.Root_bottomCenter]: position === 'bottomCenter',
            })}
        >
            <SVG
                className={classNames({
                    [styles.Icon_topRight]: position === 'topRight',
                    [styles.Icon_bottomCenter]: position === 'bottomCenter',
                })}
                src={closeIcon}
            />
        </CleanButton>
    );
};

export default DialogCloseButton;
